import { Container, Box, Grid } from "@mui/material"
import { makeStyles } from "makeStyles"
import Price from "components/Price"
import removeWhiteSpace from "@secureo/common/utils/removeWhiteSpace"
import ShieldGraphic from "svg/seriesPage/shield.svg"
import { SecurityLevelInsurance } from "@secureo/common/utils/commerceTools/graphql/queries/fetchSecurityLevelInsurancesCustomObject"

const useStyles = makeStyles()(() => ({
	shieldSize: {
		width: "140%",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
		},
	},
	shieldPosition: {
		position: "absolute",
		top: "50%",
		right: "0%",
		transform: "translate(-50%, -50%)",
		"@media only screen and (max-width: 960px)": {
			right: -150,
		},
	},
	dataHeadline: {
		textTransform: "uppercase",
		fontSize: 13,
		letterSpacing: 0.5,
	},
}))

const BurglaryProtection = ({
	bulgaryProtectionContent,
	securityLevelInsurances,
	securityGrade = "",
}: Props) => {
	const { classes } = useStyles()

	const securityLevelInsurance = securityLevelInsurances.find(
		({ label }) =>
			removeWhiteSpace(label.replace("Sicherheitsstufe ", "").split("(Sta")[0]) ===
			removeWhiteSpace(securityGrade),
	)

	return (
		<Container style={{ position: "relative", minHeight: 500 }}>
			<div className={classes.shieldPosition}>
				<ShieldGraphic className={classes.shieldSize} />
			</div>
			<Box
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "100%",
				}}
			>
				<Box py={5} px={2} style={{ maxWidth: 800, position: "relative" }}>
					<div
						dangerouslySetInnerHTML={{
							__html: bulgaryProtectionContent,
						}}
						style={{ marginTop: 40, lineHeight: 2 }}
					/>
					{securityGrade !== "keine" && (
						<Box mt={3}>
							<Grid container spacing={3}>
								<Grid item xs={12} md={4}>
									<Box mb={1} className={classes.dataHeadline}>
										Sicherheitsstufe
									</Box>
									<strong>{securityGrade}</strong>
								</Grid>
								<Grid item xs={12} md={4}>
									<Box mb={1} className={classes.dataHeadline}>
										Versicherung privat
									</Box>
									<strong>
										{securityLevelInsurance?.isSuitableForPrivate && (
											<Price
												priceInEuroCents={
													(securityLevelInsurance?.insuranceSumPrivateEur ??
														0) * 100
												}
											/>
										)}
									</strong>
								</Grid>
								<Grid item xs={12} md={4}>
									<Box mb={1} className={classes.dataHeadline}>
										Versicherung gewerblich
									</Box>
									<strong>
										{securityLevelInsurance?.isSuitableForBusiness && (
											<Price
												priceInEuroCents={
													(securityLevelInsurance?.insuranceSumBusinessEur ??
														0) * 100
												}
											/>
										)}
									</strong>
								</Grid>
							</Grid>
						</Box>
					)}
				</Box>
			</Box>
		</Container>
	)
}

interface Props {
	bulgaryProtectionContent: string
	securityGrade: string
	securityLevelInsurances: SecurityLevelInsurance[]
}

export default BurglaryProtection
